/**
 * You can use this file for your Drupal behavious
 */

(function ($, Drupal) {
  'use strict';

  /**
   * Mobile menu toggle visibility
   * @param {Object} event The event object.
   * @return {boolean} false.
   */
  function atp2017TogglerMobileMenuHandler (event) {
    const $menuBlock = $(event.data.menuBlock);
    const $searchBlock = $('#block-atp2017-search');

    event.preventDefault();

    $(this).toggleClass('close');
    $menuBlock.toggleClass('visible');
    $searchBlock.toggleClass('visible');

    return false;
  }

  Drupal.behaviors.atp2017TogglerMobileMenuHandle = {
    attach: function (context, settings) {
      $(context)
        .find('#block-atp2017-main-menu')
        .once('atp2017-toggle-mobile-menu')
        .each(function () {
          /* eslint-disable max-len */
          // Add menu toggler
          $(this)
            .before('<a href="#" id="mobile-menu-toggler" class="mobile-menu-toggler"><span>menu</span></a>')
            .parent()
              .on('click', '#mobile-menu-toggler', {'menuBlock': this}, atp2017TogglerMobileMenuHandler);

          // Add menu item togglers
          $('.menu-item--expanded', this).each(function() {
            $(this)
              .addClass('menu-item--has-children')
              .removeClass('menu-item--expanded')
              .on('click', '.menu-item-toggler', function() {
                console.log('click'); // eslint-disable-line no-console
                $(this).parent().toggleClass('menu-item--expanded');
              })
              .append('<i class="menu-item-toggler icon-close"></i>');
          });
          /* eslint-enable max-len */
        });
    }
  };

  Drupal.behaviors.atp2017TogglerMobileIsotopeControlsHandle = {
    attach: function (context, settings) {
      $(context)
        .find('#block-atp2017-isotopecontrols')
        .once('atp2017-toggle-mobile-isotopecontrols')
        .each(function () {
          /* eslint-disable max-len */

          // Add menu header togglers
          $('h5', this).each(function() {
            $(this)
              .addClass('menu-item--has-children')
              .removeClass('menu-item--expanded')
              .on('click', function() {
                $(this)
                  .parent()
                  .siblings()
                    .removeClass('menu--expanded')
                  .end()
                    .toggleClass('menu--expanded');
              })
              .append('<i class="menu-item-toggler icon-arrow"></i>');
          });

          // Add menu item togglers
          $('.has-children', this).each(function() {
            $(this)
              .addClass('menu-item--has-children')
              .removeClass('menu-item--expanded')
              .on('click', '.menu-item-toggler', function() {
                $(this).parent().toggleClass('menu-item--expanded');
              })
              .append('<i class="menu-item-toggler icon-close"></i>');
          });
          /* eslint-enable max-len */
        });
    }
  };

  Drupal.behaviors.atp2017RegisterToolTip = {
    attach: function (context, settings) {
      $('.user-register-form').on('click', '.atp-newsletter-help',
        function(event) {
          event.preventDefault();
          $('#edit-field-mailinglist-subscribe-value--description').slideToggle();
        }
      );
      $('.commerce-checkout-flow').on('click', '.atp-newsletter-help',
        function(event) {
          event.preventDefault();
          $('#edit-atp-login-register-field-mailinglist-subscribe-value--description').slideToggle();
        }
      );
    }
  };

  /**
   * Adapted from: https://css-tricks.com/NetMag/FluidWidthVideo/Article-FluidWidthVideo.php
   */
  Drupal.behaviors.atp2017VideoResize = {
    attach: function (context, settings) {
      // Find all YouTube videos
      const $allVideos = $('iframe[src^="https://player.vimeo.com/"], iframe[src^="https://www.youtube.com/"]');

      // Figure out and save aspect ratio for each video and remove the hard coded width/height
      $allVideos.each(function() {

        if (!$(this).parent('.videowrapper').length) {
          $(this).wrap('<div class="videowrapper"></div>');
        }
      });
    }
  };

  /**
   * In order to control the modal windows we use cookies.
   * To help us with the cookies we are using the JS Cookie library
   * https://github.com/js-cookie/js-cookie
   */
  Drupal.behaviors.atp2017BlocktoModal = {
    attach: function (context, settings) {
      $(context)
        .find('.region-modal > .block')
        .once('atp2017-block-to-modal')
        .each(function () {
          let blockId = $(this).attr('id');
          let cookieCloseModal = blockId + '__modal_survey--closed';
          let cookieFormSubmitted = blockId + '__form--submitted';
          let title = 'Survey';

          // Survey title
          if ($(this).children('h2').length) {
            title = $(this).children('h2').text();
            $(this).children('h2').hide();
          }

          // Create Dialog
          $(this).dialog({
            autoOpen: false,
            classes: {
              'ui-dialog': 'ui-corner-none position-fixed',
              'ui-dialog-titlebar': 'ui-corner-none'
            },
            close: function( event, ui ) {
              Cookies.set(cookieCloseModal, 1, { expires: 7 });
            },
            open: function( event, ui ) {
              // Set a cookie when the form is submitted
              $(this).find('.webform-submission-form').submit(function( event ) {
                Cookies.set(cookieFormSubmitted, 1, { expires: 90 });
              });
            },
            position: { my: 'left', at: 'left' },
            title: title
          });

          // Delay modal opening if it hasn't been previously closed
          if ((Cookies.get(cookieCloseModal) == null) && (Cookies.get(cookieFormSubmitted) == null)) {
            let $myDialog = $(this);
            window.setTimeout(
              function() {
                $myDialog.dialog('open');
              },
              8000
            );
          }
          // else {
          // console.log(cookieCloseModal + ' was previously closed.');
          // }

          // Set a cookie when the form is submitted
          $(this).find('.webform-button--submit').click(function( event ) {
            Cookies.set(cookieFormSubmitted, 1, { expires: 90 });
          });
        });
    }
  };

})(jQuery, Drupal);
